import { lazy } from "react";

// project imports
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/Authguard";
import ColorPaletteViewer from "views/utilities/ColorPaletteViewer";
import Success from "views/pages/company/Success";
import Fail from "views/pages/company/Fail";
import AddonListing from "views/pages/company/AddonListing";
import AddonSuccess from "views/pages/company/AddonSuccess";
import ManageSubscription from "views/pages/subscription/ManageSubscription";
import ManageSubscriptionResult from "views/pages/subscription/ManageSubscriptionResult";
import SubscriptionMain from "views/pages/subscription/SubscriptionMain";

// dashboard routing
const DashboardDefault = Loadable(
  lazy(() => import("views/dashboard/Default"))
);

const JPDefault = Loadable(
  lazy(() => import("views/pages/jobPosition/index"))
);

const JobPositionList = Loadable(
  lazy(() => import("views/pages/jobPosition/JPListPage"))
);

const MADetailsPage = Loadable(
  lazy(() => import("views/pages/matchAnalysis/MADetailsPageMainCard.js"))
);

const ApplicationsListForJP = Loadable(
  lazy(() => import("views/pages/jobApplication/ApplicationListingForJP.js"))
);

const ApplicationDetailPageForJP = Loadable(
  lazy(() => import("views/pages/jobApplication/ApplicantDetailsMainCardForJP"))
);

const AllApplicantList = Loadable(
  lazy(() => import("views/pages/jobApplication/AllApplicantList"))
);

const MaListingbyJP = Loadable(
  lazy(() => import("views/pages/matchAnalysis/MaListingbyJP"))
);
// AllMatchAnalysisListPage
const AllMatchAnalysisListPage = Loadable(
  lazy(() => import("views/pages/matchAnalysis/AllMatchAnalysisListPage"))
);

const HDUserDetailPage = Loadable(
  lazy(() => import("views/pages/user/HDUserDetailPage"))
);

const UserProfilePage = Loadable(
  lazy(() => import("views/pages/user/HIREDrateUserProfile"))
);

const UserSettingsPage = Loadable(
  lazy(() => import("views/pages/settings/HIREDrateUserSettings"))
);

const CompanyProfilePage = Loadable(
  lazy(() => import("views/pages/company/HDCompanyPage"))
);
const PlanUpgrade = Loadable(
  lazy(() => import("views/pages/company/PlanUpgrade"))
);
// sample page routing
const SamplePage = Loadable(lazy(() => import("views/sample-page")));

// Hiredrate Error Page
const ErrorPageDefault = Loadable(
  lazy(() => import("views/pages/error/ErrorPage"))
);

// Hiredrate Settings Page
const HIREDrateSettingsPage = Loadable(
  lazy(() => import("views/pages/settings/HIREDrateSettings"))
);


// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/",
      element: <JobPositionList />,
    },
    {
      path: "colors",
      element: <ColorPaletteViewer />,
    },
    {
      path: "dashboard",
      children: [
        {
          path: "default",
          element: <DashboardDefault />,
        },
        {
          path: "error",
          element: <ErrorPageDefault />,
        },
      ],
    },
    {
      path: "jp",
      children: [
        {
          path: "job-positions",
          element: <JobPositionList />,
        },
        {
          path: "job-positions-detail/:id",
          element: <JPDefault />,
        },
        {
          path: "job-positions-detail/:jobPositionId/job-applicants-detail/:applicantId",
          element: <ApplicationDetailPageForJP />,
        },
        {
          path: "job-positions-detail/:id/job-applicants-card",
          element: <ApplicationsListForJP />,
        },
        {
          path: "job-positions-detail/:id/match-analysis",
          element: <MaListingbyJP />,
        },
        {
          path: "job-positions-detail/:jobPositionId/match-analytics-detail/:matchAnalyticsId",
          element: <MADetailsPage />,
        },
        {
          path: "job-positions-detail/:id/job-applicants-detail/:applicantId/match-analysis",
          // element: <MatchAnalysisList />,
          element: <MaListingbyJP />,
        },
        {
          path: "job-positions-detail/:jobPositionId/job-applicants-detail/:applicantId/match-analytics-detail/:matchAnalyticsId",
          element: <MADetailsPage />,
        },
      ],
    },
    {
      path: "settings",
      children: [
        {
          path: ":profileLoad/user-profile/:userUId",
          element: <UserProfilePage />,
        },
        {
          path: "user-settings",
          element: <UserSettingsPage />,
        },
        {
          path: "company-profile/:companyId",
          element: <CompanyProfilePage />,
        },
        {
          path: "planupgrade",
          element: <PlanUpgrade />,
        },
        {
          path: "planupgrade/payment-success",
          element: <Success />,
        },
        {
          path: "planupgrade/payment-failed",
          element: <Fail />,
        },
        {
          path: "user-deatils/:userUId",
          element: <HDUserDetailPage />,
        },
        {
          path: "hiredrate-settings",
          element: <HIREDrateSettingsPage />,
        },
        {
          path: "addons",
          element: <AddonListing />,
        },
        {
          path: "addons/payment-success",
          element: <AddonSuccess/>,
        },
        {
          path: "subscription/manage-subscription",
          element: <ManageSubscription />,
        },
        {
          path: "subscription/manage-subscription-result",
          element: <ManageSubscriptionResult />,
        },
        {
          path: "subscription",
          element: <SubscriptionMain />,
        },
      ],
    },
    {
      path: "ma",
      children: [
        {
          path: "match-analysis",
          element: <AllMatchAnalysisListPage />,
        },
      ],
    },
    {
      path: "ap",
      children: [
        {
          path: "job-applicants",
          element: <AllApplicantList />,
        },
      ],
    },
    {
      path: "sample-page",
      element: <SamplePage />,
    }
  ],
};

export default MainRoutes;